import {useContext} from "react";
import {ToastContext} from "@/config/ToastContext/ToastContext.tsx";

export const useToastApi = () => {
  const context = useContext(ToastContext);
  if (!context) throw new Error('useToastApi must be used within a MessageProvider');

  return context.messageApi;
};